const KEY = "rf_src";

export function captureSource() {
  try {
    if (localStorage.getItem(KEY)) return;
    const q = new URLSearchParams(window.location.search);
    const ref = document.referrer && !document.referrer.startsWith(window.location.origin) ? document.referrer : "";
    localStorage.setItem(KEY, JSON.stringify({
      referrer: ref.slice(0, 500),
      landing: window.location.pathname + window.location.search,
      utm_source: q.get("utm_source") || q.get("ref") || "",
      utm_medium: q.get("utm_medium") || "",
      utm_campaign: q.get("utm_campaign") || "",
    }));
  } catch (_) {}
}

export function getSource() {
  try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (_) { return {}; }
}
